import { render, staticRenderFns } from "./questionManagement.vue?vue&type=template&id=461bee1b"
import script from "./questionManagement.vue?vue&type=script&lang=js"
export * from "./questionManagement.vue?vue&type=script&lang=js"
import style0 from "./questionManagement.vue?vue&type=style&index=0&id=461bee1b&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports